exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icp__input[data-v-909f1834] {\n  border-radius: 4px;\n  background-color: #000 !important;\n}\n.mt-2[data-v-909f1834] {\n  margin-top: 10px;\n}\n.color-prev[data-v-909f1834] {\n  height: 50px;\n  width: 50px;\n  border-radius: 50px;\n  margin: 0 auto;\n}\n", ""]);

// exports
